import { __assign } from 'tslib';
import PropTypes from 'prop-types';

var PagePositions;
(function (PagePositions) {
    PagePositions["CENTER"] = "center";
    PagePositions["LEFT"] = "left";
    PagePositions["RIGHT"] = "right";
})(PagePositions || (PagePositions = {}));
var SidebarPositions;
(function (SidebarPositions) {
    SidebarPositions["LEFT"] = "left";
    SidebarPositions["RIGHT"] = "right";
})(SidebarPositions || (SidebarPositions = {}));
var mainPropTypes = {
    className: PropTypes.string,
    headerComponent: PropTypes.node,
    footerComponent: PropTypes.node,
    'data-testid': PropTypes.string,
};
var propTypes = __assign(__assign({}, mainPropTypes), { isOpen: PropTypes.bool, zIndex: PropTypes.number, position: PropTypes.oneOf([SidebarPositions.LEFT, SidebarPositions.RIGHT]), hasBackgroundBlur: PropTypes.bool, overlayClassName: PropTypes.string, onTransitionEnd: PropTypes.func });
var pagePropTypes = __assign(__assign({}, mainPropTypes), { slideTo: PropTypes.oneOf([
        PagePositions.CENTER,
        PagePositions.LEFT,
        PagePositions.RIGHT,
    ]), onTransitionEnd: PropTypes.func });
var layoutPropTypes = __assign(__assign({}, mainPropTypes), { headerClassName: PropTypes.string, bodyClassName: PropTypes.string, footerClassName: PropTypes.string });
var defaultProps = {
    isOpen: false,
    zIndex: 20,
    position: SidebarPositions.RIGHT,
    'data-testid': 'sidebar',
};
var pageDefaultProps = {
    slideTo: PagePositions.CENTER,
};

export { PagePositions, SidebarPositions, defaultProps, layoutPropTypes, pageDefaultProps, pagePropTypes, propTypes };
